import { render, staticRenderFns } from "./RbToGoogleAndReviewIcon.vue?vue&type=template&id=ad09c774&functional=true&"
import script from "./RbToGoogleAndReviewIcon.vue?vue&type=script&lang=js&"
export * from "./RbToGoogleAndReviewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports